import { Switch } from "@shared/ui";
import { DisabledPopover } from "@shared/ui/DisabledPopover";
import { Card, Divider, Flex, SwitchProps } from "antd";
import classNames from "classnames";
import { Sparkles } from "lucide-react";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

export default function ControlsCard({
  icon,
  title,
  subtitle,
  description,
  switchProps,
  className: propsClassName,
  active,
  isDisabled,
}: {
  icon?: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  description?: ReactNode;
  switchProps: SwitchProps;
  className?: string;
  active?: boolean;
  isDisabled?: boolean;
}) {
  const { className, ...rest } = switchProps;
  return (
    <Card
      className={classNames(styles.controlsCard, propsClassName, {
        [styles.active]: active,
      })}
      styles={{
        body: {
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <div style={{ flex: 1 }}>
        <Flex justify="space-between" style={{ width: "100%" }}>
          <Card.Meta
            title={title}
            description={subtitle}
            avatar={icon}
            className={styles.cardMeta}
          />
          <DisabledPopover isDisabled={isDisabled || false}>
            <Switch
              disabled={isDisabled || false}
              checkedChildren={
                <Sparkles fill="#635bff" color="#635bff" size={12} />
              }
              unCheckedChildren={
                <Sparkles fill="#a3acb9" color="#a3acb9" size={12} />
              }
              className={classNames(styles.switch, className)}
              size="default"
              {...rest}
            />
          </DisabledPopover>
        </Flex>
      </div>
      {description ? (
        <div>
          <Divider style={{ margin: "15px 0" }} />
          {description}
        </div>
      ) : null}
    </Card>
  );
}
